import React, { useEffect } from "react";
import "../styles/BankHoildays.css";
import FlagIcon from "../assets/photos/flag.png"; // Republic Day image
import Shiva from "../assets/photos/lord-shiva.png";
import Maharaj from "../assets/photos/shivaji-maharaj.png";
import Holi from "../assets/photos/holi.png";
import Gudi from "../assets/photos/gudi.png";
import Ramzan from "../assets/photos/ramzan.png"
import Ram from "../assets/photos/ram-navmi.png";
import Mahavir from "../assets/photos/mahavir.png";
import Friday from "../assets/photos/good-friday.png";
import Ambedkar from "../assets/photos/ambedkar.png";
import Maharastra from "../assets/photos/maharastra-din.png";
import Buddha from "../assets/photos/buddha.png";
import BakriEid from "../assets/photos/bakri-eid.png";
import Moharam from "../assets/photos/moharam.png";
import Parsi from "../assets/photos/parsi-new-year.png";
import Ganesh from "../assets/photos/ganesh-chaturthi.png";
import Milad from "../assets/photos/milad.png";
import Gandhi from "../assets/photos/gandhi.png";
import Dasara from "../assets/photos/dasara.png";
import Laxmi from "../assets/photos/laxmi.png";
import Diwali from "../assets/photos/diwali.png";
import Guru from "../assets/photos/guru.png";
import Chrismas from "../assets/photos/chrismas.png";
import BankHoliday from "../assets/photos/holiday.png";
import Sunday from "../assets/photos/sunday.png";
import Saturday from "../assets/photos/saturday.png"



// Icons for holidays
const holidayIcons = {
    "Republic Day": FlagIcon,
    "Independence Day": FlagIcon,
    "Chhatrapati Shivaji Maharaj Jayanti": Maharaj,
    "Mahashivratri": Shiva,
    "Holi (Second Day)": Holi,
    "Gudhi Padwa" : Gudi,
    "Ramzan‑Id (Id‑Ul‑Fitra)": Ramzan,
    "Ram Navami": Ram,
    "Mahavir Janmakalyanak": Mahavir,
    "Bank Holiday": BankHoliday,
    "Good Friday": Friday,
    "Dr. Babasaheb Ambedkar Jayanti": Ambedkar,
    "Maharashtra Din": Maharastra,
    "Buddha Pournima": Buddha,
    "Bakri Id (Id‑Uz‑Zuha)": BakriEid,
    "Moharum": Moharam,
    "Parsi New Year (Shahenshahi)": Parsi,
    "Ganesh Chaturthi": Ganesh,
    "Id‑E‑Milad": Milad,
    "Mahatma Gandhi Jayanti": Gandhi,
    "Dasara": Dasara,
    "Diwali Amavasya (Laxmi Pujan)": Laxmi,
    "Diwali (Bali Pratipada)": Diwali,
    "Guru Nanak Jayanti": Guru,
    "Christmas": Chrismas,
    "All Sundays": Sunday,
    "2nd & 4th Saturday":Saturday,
};

// Holidays list for 2026
const holidays2026 = [
    { name: "Republic Day", date: "26 Jan 2026", day: "Monday" },
    { name: "Chhatrapati Shivaji Maharaj Jayanti", date: "19 Feb 2026", day: "Thursday" },
    { name: "Mahashivratri", date: "15 Feb 2026", day: "Sunday" },
    { name: "Holi (Second Day)", date: "03 Mar 2026", day: "Tuesday" },
    { name: "Gudhi Padwa", date: "19 Mar 2026", day: "Thursday" },
    { name: "Ramzan‑Id (Id‑Ul‑Fitra)", date: "21 Mar 2026", day: "Saturday" },
    { name: "Ram Navami", date: "26 Mar 2026", day: "Thursday" },
    { name: "Mahavir Janmakalyanak", date: "31 Mar 2026", day: "Tuesday" },
    { name: "Bank Holiday", date: "1 Apr 2026", day: "Wednesday" },
    { name: "Good Friday", date: "03 Apr 2026", day: "Friday" },
    { name: "Dr. Babasaheb Ambedkar Jayanti", date: "14 Apr 2026", day: "Tuesday" },
    { name: "Maharashtra Din", date: "01 May 2026", day: "Friday" },
    { name: "Buddha Pournima", date: "01 May 2026", day: "Friday" },
    { name: "Bakri Id (Id‑Uz‑Zuha)", date: "28 May 2026", day: "Thursday" },
    { name: "Moharum", date: "26 Jun 2026", day: "Friday" },
    { name: "Independence Day", date: "15 Aug 2026", day: "Saturday" },
    { name: "Parsi New Year (Shahenshahi)", date: "15 Aug 2026", day: "Saturday" },
    { name: "Ganesh Chaturthi", date: "14 Sep 2026", day: "Monday" },
    { name: "Id‑E‑Milad", date: "26 Aug 2026", day: "Wednesday" },
    { name: "Mahatma Gandhi Jayanti", date: "02 Oct 2026", day: "Friday" },
    { name: "Dasara", date: "20 Oct 2026", day: "Tuesday" },
    { name: "Diwali Amavasya (Laxmi Pujan)", date: "08 Nov 2026", day: "Sunday" },
    { name: "Diwali (Bali Pratipada)", date: "10 Nov 2026", day: "Tuesday" },
    { name: "Guru Nanak Jayanti", date: "24 Nov 2026", day: "Tuesday" },
    { name: "Christmas", date: "25 Dec 2026", day: "Friday" },
    { name: "All Sundays", date: "Weekly Off", day: "NA" },
    { name: "2nd & 4th Saturday", date: "Every Month", day: "NA" }
];

const BankHolidays = () => {
    useEffect(() => {
        const elements = document.querySelectorAll(".holiday-card, .fade-in");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                    }
                });
            },
            { threshold: 0.2 }
        );
        elements.forEach((el) => observer.observe(el));

        const hero = document.querySelector(".bankholidays-hero");
        if (hero) hero.classList.add("visible");

        return () => observer.disconnect();
    }, []);

    return (
        <main className="bankholidays-container">
            {/* Hero Section */}
            <section className="bankholidays-hero fade-in">
                <h1>Bank Holidays</h1>
                <p>All Public Holidays for the Year 2026</p>
            </section>

            {/* Holidays Cards Section */}
            <section className="holidays-section">
                <div className="holidays-grid">
                    {holidays2026.map((holiday, index) => (
                        <div key={index} className="holiday-card">
                            {holidayIcons[holiday.name] && (
                                <img
                                    src={holidayIcons[holiday.name]}
                                    alt={holiday.name}
                                    className="holiday-icon"
                                />
                            )}
                            <h3>{holiday.name}</h3>
                            <p className="date">{holiday.date}</p>
                            <p className="day">{holiday.day}</p>
                        </div>
                    ))}
                </div>
            </section>
        </main>
    );
};

export default BankHolidays;
